import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import helpEn from '../locales/help/en.json';
import helpAr from '../locales/help/ar.json';
import helpUr from '../locales/help/ur.json';
import helpHi from '../locales/help/hi.json';
import helpBn from '../locales/help/bn.json';
import helpSi from '../locales/help/si.json';
import helpNe from '../locales/help/ne.json';

export const HELP_I18N_STORAGE_KEY = 'ops_help_language';

export type HelpLanguage = 'en' | 'ar' | 'ur' | 'hi' | 'bn' | 'si' | 'ne';

export const SUPPORTED_HELP_LANGUAGES: HelpLanguage[] = [
  'en',
  'ar',
  'ur',
  'hi',
  'bn',
  'si',
  'ne',
];

const HELP_RTL_LANGUAGES: HelpLanguage[] = ['ar', 'ur'];

export const helpI18n = i18n.createInstance();

if (!localStorage.getItem(HELP_I18N_STORAGE_KEY)) {
  localStorage.setItem(HELP_I18N_STORAGE_KEY, 'en');
}

helpI18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: helpEn },
      ar: { translation: helpAr },
      ur: { translation: helpUr },
      hi: { translation: helpHi },
      bn: { translation: helpBn },
      si: { translation: helpSi },
      ne: { translation: helpNe },
    },
    lng: localStorage.getItem(HELP_I18N_STORAGE_KEY) || 'en',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_HELP_LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: HELP_I18N_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export const setHelpLanguage = (lng: HelpLanguage) => {
  localStorage.setItem(HELP_I18N_STORAGE_KEY, lng);
  void helpI18n.changeLanguage(lng);
};

/** @deprecated Help language follows app language via AppI18nProvider */
export const toggleHelpLanguage = () => {
  const next: HelpLanguage = helpI18n.language.startsWith('ar') ? 'en' : 'ar';
  setHelpLanguage(next);
};

export const isHelpArabic = (language = helpI18n.language): boolean =>
  language.startsWith('ar');

export const isHelpRtl = (language = helpI18n.language): boolean =>
  HELP_RTL_LANGUAGES.some((code) => language.startsWith(code));
